export default __webpack_public_path__ + "static/coding-amico-64a0fc2ea1bbaa93db42d66a5ce12187.svg";